import { render, staticRenderFns } from "./printFiles.vue?vue&type=template&id=a97cb624"
import script from "./printFiles.vue?vue&type=script&lang=js"
export * from "./printFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports